import React, { useState } from "react";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import { Tooltip } from "antd";
import Styles from "./Styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { filterVisibleTopics } from "../../utils";

const statusList = [
  { name: "all", value: "all", label: "All" },
  {
    name: "active",
    value: "active",
    label: "Active",
  },
  {
    name: "inactive",
    value: "inactive",
    label: "Inactive",
  },
];

export default function ManageUsersFilter() {
  const state = useSelector((state) => state.manageUsers);
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { updatefiltersDataMU, updateStatus } = bindActionCreators(
    Actions,
    dispatch,
  );
  const [fromDate, setFromDate] = useState(state.fromdate);
  const [tillDate, setTillDate] = useState(state.tilldate);
  const [activeFromDate, setActiveFromDate] = useState(state.activefromdate);
  const [activeTillDate, setActiveTillDate] = useState(state.activetilldate);
  const [selectedRoleType, setSelectedRoleType] = useState(state.role);
  const [domains, setSelectedDomains] = useState(state.domainFilter);
  const [selectedStatus, setSelectedStatus] = useState(state.statusValue);
  const [selectedUserType, setSelectedUserType] = useState(state.userType);
  const onChangeUserType = (e) => {
    setSelectedUserType(e);
  };
  const onChangeDomainType = (e) => {
    setSelectedDomains(e);
  };
  const onChangeRoleType = (e) => {
    setSelectedDomains([]);
    setSelectedRoleType(e);
  };

  const onChangeStatusType = (e) => {
    setSelectedStatus(e);
    //  updateStatus(e)
  };
  const onChangeFromdate = (e) => {
    setFromDate(e.target.value);
  };
  const onChangeTilldate = (e) => {
    setTillDate(e.target.value);
  };
  const onChangeActiveFromdate = (e) => {
    setActiveFromDate(e.target.value);
  };
  const onChangeActiveTilldate = (e) => {
    setActiveTillDate(e.target.value);
  };
  const onClearFromdate = () => {
    setFromDate("");
  };
  const onClearTilldate = () => {
    setTillDate("");
  };
  const onClearActiveFromdate = () => {
    setActiveFromDate("");
  };
  const onClearActiveTilldate = () => {
    setActiveTillDate("");
  };

  const userTypeOptions = [
    { name: "all", value: "all", label: "All" },
    { name: "employee", value: "1", label: "Employee" },
    { name: "customer", value: "2", label: "Customer" },
    { name: "partner", value: "3", label: "Partner" },
  ];
  const maxDate = () => {
    let newDate = new Date();
    return newDate.toISOString().split("T")[0];
  };
  const minDate = (date) => {
    if (date === "") {
      return "";
    }
    let newDate = new Date(date);
    return newDate.toISOString().split("T")[0];
  };
  const onSubmit = () => {
    let payload = {
      fromDate: fromDate,
      tillDate: tillDate,
      activeFromDate: activeFromDate,
      activeTillDate: activeTillDate,
      userType: selectedUserType,
      role: selectedRoleType,
      domain: domains,
      status: selectedStatus,
    };

    updatefiltersDataMU(payload);
  };

  const renderClear = (value, onClear) =>
    value !== "" && (
      <Tooltip
        placement="top"
        title={() => (
          <span style={{ color: "black", fontSize: "10px" }}>Clear date</span>
        )}
        color="#fff"
      >
        <i
          className="fa fa-close"
          style={{ fontSize: "14px", cursor: "pointer", marginLeft: "6px" }}
          onClick={onClear}
        ></i>
      </Tooltip>
    );

  return (
    <>
      <div
        className="mt-3"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div>
          <h1 style={{ fontSize: "22px" }}>Admin Filters</h1>
        </div>
        <div>
          <button
            style={{
              border: "1px solid var(--light_color_shade)",
              cursor: "pointer",
              color: "#fff",
              background: "var(--light_color_shade)",
              borderRadius: "4px",
              paddingInline: "10px",
              paddingBlock: "5px",
            }}
            onClick={() => onSubmit()}
          >
            Apply Filters
          </button>
        </div>
      </div>
      <hr className="mt-3 mb-3" />
      <div className="mb-3" style={{ display: "flex", flexWrap: "wrap" }}>
        <div
          className="mt-1"
          style={{
            display: "flex",
            alignItems: "baseline",
            marginRight: "20px",
          }}
        >
          <div style={{ marginRight: "10px", fontSize: "14px" }}>User Type</div>
          <div>
            <MultiSelectCm
              isMulti={false}
              value={selectedUserType}
              options={userTypeOptions}
              onChangeFunc={onChangeUserType}
            />
          </div>
        </div>
        <div
          className="mt-1"
          style={{ display: "flex", alignItems: "baseline" }}
        >
          <div style={{ marginRight: "10px", fontSize: "14px" }}>Role</div>
          <div>
            <MultiSelectCm
              isMulti={false}
              value={selectedRoleType}
              options={[
                {
                  name: "all",
                  value: "all",
                  label: "All",
                },
              ].concat(state.roleList)}
              onChangeFunc={onChangeRoleType}
            />
          </div>
        </div>
      </div>

      <div className="mb-3" style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            marginRight: "20px",
          }}
        >
          <div style={{ marginRight: "10px", fontSize: "14px" }}>Status</div>
          <div>
            <MultiSelectCm
              isMulti={false}
              value={selectedStatus}
              options={statusList}
              onChangeFunc={onChangeStatusType}
            />
          </div>
        </div>
        {(selectedRoleType.name === "Expert" ||
          selectedRoleType.name === "CM") && (
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <div style={{ marginRight: "10px", fontSize: "14px" }}>Domains</div>
            <div style={{ minWidth: "200px" }}>
              <MultiSelectCm
                isMulti={true}
                value={domains}
                options={filterVisibleTopics(userState.expertTopics)}
                onChangeFunc={onChangeDomainType}
              />
            </div>
          </div>
        )}
      </div>

      <hr className="mt-3 mb-3" />

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "nowrap",
            minWidth: 0,
          }}
        >
          <div style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Created From&nbsp;</div>
          <div
            style={{ marginTop: "7px", display: "flex", alignItems: "center" }}
          >
            <input
              onChange={(e) => onChangeFromdate(e)}
              value={fromDate}
              className={Styles.dateInputcss}
              type="date"
              max={maxDate()}
            />
            {renderClear(fromDate, onClearFromdate)}
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "nowrap",
            minWidth: 0,
          }}
        >
          <div style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Created Till&nbsp;</div>
          <div
            style={{ marginTop: "7px", display: "flex", alignItems: "center" }}
          >
            <input
              min={minDate(fromDate)}
              value={tillDate}
              onChange={(e) => onChangeTilldate(e)}
              className={Styles.dateInputcss}
              type="date"
              max={maxDate()}
            />
            {renderClear(tillDate, onClearTilldate)}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", marginTop: "20px" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "nowrap",
            minWidth: 0,
          }}
        >
          <div style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Active From&nbsp;</div>
          <div
            style={{ marginTop: "7px", display: "flex", alignItems: "center" }}
          >
            <input
              onChange={(e) => onChangeActiveFromdate(e)}
              value={activeFromDate}
              className={Styles.dateInputcss}
              type="date"
              max={maxDate()}
            />
            {renderClear(activeFromDate, onClearActiveFromdate)}
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "nowrap",
            minWidth: 0,
          }}
        >
          <div style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Active Till&nbsp;</div>
          <div
            style={{ marginTop: "7px", display: "flex", alignItems: "center" }}
          >
            <input
              min={minDate(activeFromDate)}
              value={activeTillDate}
              onChange={(e) => onChangeActiveTilldate(e)}
              className={Styles.dateInputcss}
              type="date"
              max={maxDate()}
            />
            {renderClear(activeTillDate, onClearActiveTilldate)}
          </div>
        </div>
      </div>
    </>
  );
}
